"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSsoIdentity = void 0;
const cookies_1 = require("./cookies");
const core_utility_1 = require("@built/core-utility");
/**
 * Gets the last auth user's identity if they are logged in via SSO.
 */
const getSsoIdentity = () => {
    var _a;
    const identityCookie = (0, cookies_1.getLastAuthUserCookieByType)('idToken');
    if (!identityCookie) {
        return;
    }
    const lastUserIdentity = (0, core_utility_1.parseJwtPayload)(identityCookie.value);
    const primaryIdentity = (_a = lastUserIdentity === null || lastUserIdentity === void 0 ? void 0 : lastUserIdentity.identities) === null || _a === void 0 ? void 0 : _a.find((i) => /true/i.test(i.primary));
    if (!primaryIdentity) {
        return;
    }
    return primaryIdentity.providerType ? lastUserIdentity : undefined;
};
exports.getSsoIdentity = getSsoIdentity;
